import React from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Container } from 'react-bootstrap'
import { plans, useUserService } from '@abroad/components'
import { LearnAboutCoaching, PageHeader } from '../components/common'
import SessionsTabbedView from '../components/sessions/SessionsTabbedView'

const SessionPractice = () => {
  const { user } = useUserService()
  const location = useLocation()
  const isSessionsRoute = location.pathname.startsWith('/coaching/sessions')
  const [isCalendarView, setIsCalendarView] = React.useState(false)

  const renderSessionsComponents = () => {
    if (user.planCode === plans.free.code) {
      return <FreePlanSession />
    }
    const tabbedView = (
      <SessionsTabbedView
        location={location}
        showTabs={isSessionsRoute}
        onCalendarViewChange={setIsCalendarView}
        isCalendarView={isCalendarView}
      />
    )
    if (user.planCode === plans.growth.code) {
      return (
        <>
          {tabbedView}
          <FreePlanSession />
        </>
      )
    }
    return tabbedView
  }

  const renderHelmet = () => (
    <Helmet>
      <title>{'Sessions | Abroad'}</title>
      <meta name='title' content={'Sessions | Abroad'}></meta>
      <meta property='og:title' content={'Sessions | Abroad'}></meta>
      <meta property='twitter:title' content={'Sessions | Abroad'}></meta>
      <link
        rel='canonical'
        href={`${process.env.REACT_APP_DOMAIN}/coaching/sessions`}></link>
      <meta
        property='og:url'
        content={`${process.env.REACT_APP_DOMAIN}/coaching/sessions`}></meta>
      <meta
        property='twitter:url'
        content={`${process.env.REACT_APP_DOMAIN}/coaching/sessions`}></meta>
    </Helmet>
  )

  return (
    <>
      {renderHelmet()}
      <main>
        <Container fluid className='px-0 g-0'>
          {!isCalendarView && <PageHeader title='Sessions' />}
          {renderSessionsComponents()}
        </Container>
      </main>
    </>
  )
}

const FreePlanSession = () => {
  return (
    <div className='my-4'>
      <LearnAboutCoaching
        titleFn={() => {
          return (
            <h3 className='s2 text-black mb-0'>
              Your Personalized <br />
              Coaching Space Awaits
            </h3>
          )
        }}
        detailsText={`Step into a personalized coaching experience designed just for you. After beginning your journey with a coach, the ‘sessions’ tab is where they will provide invaluable post-session notes and actionable practices to amplify your growth.`}
        detailsTextClasses='fw-normal'
        plan={plans.coaching.code}
        imageFilename='learn-more-1.jpg'
        imgCropFP={{
          ar: '4:5',
          'fp-x': 0.51,
          'fp-y': 0,
          auto: 'format',
        }}
        buttonText='Inquire about Coaching'
      />
    </div>
  )
}

export default SessionPractice
